var AhoyService = {
  initialize: function(){
  },
  track: function(name,properties){
    var defaults = {
      metadata: {
        user_content_id: EF.enrollment.id,
        type: name,
        lang: EF.language
      }
    };
    if (EF.module){
      defaults.metadata.module = EF.module.attributes.key;
      if (EF.module.currentActivity){
        defaults.metadata.activity = EF.module.attributes.key;
        if (EF.module.currentActivity.currentPage){
          defaults.metadata.page = EF.module.currentActivity.currentPage.attributes.key;
        }
      }
    }
    var data = Object.assign({}, defaults, properties);
    // TTD - need to actually hook this up to ahoy
    console.log("Ahoy Track:",name,data);
  }
};

module.exports = AhoyService;
